import { c as _c } from "react/compiler-runtime";
import { Tooltip } from "@flat-ui";
import { useDateTime } from "@hooks/use-date-time";
/**
 * Renders a date with relative/absolute display and a tooltip showing the full date.
 * Uses relative formatting for recent dates (e.g. "2 days ago") with an absolute tooltip,
 * and absolute formatting for older dates.
 */
export function DateCell(t0) {
  const $ = _c(15);
  const {
    date,
    shouldShowTimeInTooltip: t1
  } = t0;
  const shouldShowTimeInTooltip = t1 === undefined ? false : t1;
  const {
    formatDateWithTooltip,
    formatDateTime
  } = useDateTime();
  let t2;
  if ($[0] !== date || $[1] !== formatDateWithTooltip) {
    t2 = formatDateWithTooltip(date);
    $[0] = date;
    $[1] = formatDateWithTooltip;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    displayDate,
    tooltipDate: absoluteDate
  } = t2;
  let t3;
  if ($[3] !== absoluteDate || $[4] !== date || $[5] !== formatDateTime || $[6] !== shouldShowTimeInTooltip) {
    t3 = shouldShowTimeInTooltip ? formatDateTime(date) : absoluteDate;
    $[3] = absoluteDate;
    $[4] = date;
    $[5] = formatDateTime;
    $[6] = shouldShowTimeInTooltip;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const tooltipDate = t3;
  let t4;
  if ($[8] !== tooltipDate) {
    t4 = tooltipDate ? <var>{tooltipDate}</var> : "";
    $[8] = tooltipDate;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== displayDate) {
    t5 = <var>{displayDate}</var>;
    $[10] = displayDate;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <Tooltip component="div" title={t4}>{t5}</Tooltip>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}